'use strict'

import { logoComponent } from './components/logo/logo'

import './styles/globals.scss'
import { welcomeForm } from './components/welcomeForm/welcomeFormAndInitiation'

logoComponent()
welcomeForm('player-one-name')
